import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import Phone from './Phone'
import ShortText from './ShortText'
import SingleChoice from './SingleChoice'
import LongText from './LongText'
import DatePickers from './DatePicker'

const IndustrialSafetyTrainingForm = () => {


    const yesOrNoData = [
        {
            id: 1,
            label: "بله",
            checked: false
        },
        {
            id: 2,
            label: "خیر",
            checked: false
        },
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم آموزش ایمنی صنعتی'} subHeader={'برای ثبت نام در دوره آموزشی ایمنی صنعتی، فرم زیر را تکمیل کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'آدرس ایمیل'} />
                <Phone header={'شماره تلفن'}/>
                <ShortText header={'نام شرکت'}/>
                <ShortText header={'عنوان شغلی'}/>
                <SingleChoice header={'آیا قبلاً در دوره‌های آموزشی ایمنی شرکت کرده‌اید؟'} options={yesOrNoData}/>
                <LongText header={'لطفاً هرگونه موضوع ایمنی خاصی را که می‌خواهید پوشش داده شود، فهرست کنید:'}/>
                <DatePickers header={'تاریخ ترجیحی آموزش'}/>
            </Grid>
        </Grid>
    )
}

export default IndustrialSafetyTrainingForm
